import { render, staticRenderFns } from "./VuetableFieldCheckbox.vue?vue&type=template&id=b34f41fc"
import script from "./VuetableFieldCheckbox.vue?vue&type=script&lang=js"
export * from "./VuetableFieldCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports